import { render, staticRenderFns } from "./RealTimeClock.vue?vue&type=template&id=a2b30d3c&"
import script from "./RealTimeClock.vue?vue&type=script&lang=js&"
export * from "./RealTimeClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports